<template>
    <div class="infoBar w-100 d-block"
         :class="[!$page.props.infobar.color ? 'bg-orange' : '']"
         style="max-width: unset !important;"
         :style="{'background': $page.props.infobar.color }"
    >
        <v-container class="align-center py-2" :class="$vuetify.display.smAndDown ? 'ga-4' : 'ga-8'">
            <div class="opacity-75" :class="$vuetify.display.smAndDown ? 'h-100' : ''" id="bell">
                <v-icon :icon="mdiBellOutline" :class="getTextColor"></v-icon>
            </div>
            <div class="w-100 d-flex" :class="$vuetify.display.smAndDown ? 'flex-column ga-1' : ' ga-4'">
            <span id="infoBarText" :class="getTextColor" class="d-flex align-center font-weight-bold">{{
                    $page.props.infobar.text
                }}</span>
                <a :href="$page.props.infobar.link" :target="$page.props.infobar.blank ? '_blank' : '_self'"
                   id="infoBarlink">
                    <div v-if="$page.props.infobar.link">
                        <v-btn
                            v-if="!display"
                            variant="outlined"
                            rounded="8"
                            :class="getTextColor"
                            class="font-weight-bold text-body-2 h-auto py-2"
                            density="default"
                        >
                            {{ !$page.props.infobar.description ? $t('search.link') : $page.props.infobar.description }}
                        </v-btn>
                        <p v-else class="text-decoration-underline">{{ !$page.props.infobar.description ? $t('search.link') : $page.props.infobar.description }}</p>
                    </div>
                </a>
            </div>
            <div class="opacity-75 d-flex" :class="$vuetify.display.smAndDown ? 'h-100' : 'align-end'">
                <v-icon id="cancel" :icon="mdiClose" :class="getTextColor" class="cancel" @click="closeInfoBar" role="button" aria-label="Close"></v-icon>
            </div>
        </v-container>
    </div>
</template>
<script setup>
import {
    mdiBellOutline, mdiClose
} from "@mdi/js";
import {router, usePage} from "@inertiajs/vue3";
import {computed, inject} from "vue";
import {useDisplay} from "vuetify";

const route = inject('route');
const display = useDisplay().smAndDown;

const closeInfoBar = () => {
    router.post(route('closeInfobar'));
}

const getTextColor = computed(() => {
    const color = usePage().props.infobar.color ?? '#EE8025';
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155 ? 'text-grey-darken-1' : 'text-white';
});
</script>
<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
.infoBar {
    z-index: 2000;
    left: 0;
    top: 0;

    .v-container {
        display: flex;
        @media #{map.get($display-breakpoints, 'sm-and-down')} {
            display: grid !important;
            grid-template-columns: 0.1fr 1fr 0.1fr;
            grid-template-areas: 'bell infoBarText cancel'
                                'bell infoBarLink cancel';
            grid-row-gap: 0 !important;
        }

        #infoBarlink {
            grid-area: infoBarLink;
        }

        #cancel {
            grid-area: cancel;
            margin-left: auto;
            cursor: pointer;
        }

        #infoBarText {
            grid-area: infoBarText;
        }

        #bell {
            grid-area: bell;
        }

        .v-btn {
            text-transform: unset !important;
        }
    }
}
</style>
